import { youtubeEmbedUrl } from "../lib/youtubeVideos";

export default function YoutubeArticleEmbed({
  videoId,
  title = "Video",
  className = "jw-public-article-video",
  playerClassName = "jw-public-article-video__player",
}) {
  const embedSrc = youtubeEmbedUrl(videoId);
  if (!embedSrc) return null;

  return (
    <div className={className} aria-label={title}>
      <div className={playerClassName}>
        <iframe
          src={embedSrc}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </div>
  );
}
